import {
  Accordion as AccordionBase,
  AccordionDetails,
  AccordionSummary,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';

import ExpandIcon from '@/assets/icons/dropdown-arrow.svg?react';

type Props = React.PropsWithChildren<{
  label: string;
  expanded: boolean;
  onChange?: (event: React.SyntheticEvent, expanded: boolean) => void;
  baseSx?: SxProps<Theme>;
  summarySx?: SxProps<Theme>;
  detailsSx?: SxProps<Theme>;
}>;

export const Accordion: React.FC<Props> = ({
  children,
  label,
  expanded,
  onChange,
  baseSx,
  summarySx,
  detailsSx,
}: Props): React.ReactElement => (
  <AccordionBase expanded={expanded} onChange={onChange} sx={baseSx}>
    <AccordionSummary expandIcon={<ExpandIcon />} sx={summarySx}>
      <Typography variant="h7">{label}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={detailsSx}>{children}</AccordionDetails>
  </AccordionBase>
);
